import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';


interface Props {
  steps?: string[];
  failedStep?: number;
  activeStep?: number;
}

export default function HorizontalStepperWithError(props: Props) {
  const {
    steps = [
      'Εκκίνηση διαδικασίας έγκρισης',
      'Σε κατάσταση εισαγωγής Omeka',
      'Επιτυχής εισαγωγή Omeka',],
    activeStep = -1,
    failedStep
  } = props;

  const isStepFailed = (step: number) => {
    return step === failedStep;
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const labelProps: {
            optional?: React.ReactNode;
            error?: boolean;
          } = {};
          if (isStepFailed(index)) {
            labelProps.optional = (
              <Typography variant='caption' color='error'>
                Αποτυχία εισαγωγής
              </Typography>
            );
            labelProps.error = true;
          }

          return (
            <Step key={label}>
              {/* <CircularProgress /> */}
              <StepLabel StepIconComponent={activeStep == index && !isStepFailed(index) 
                ? CircularProgress
                : undefined} {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}